import { Box, Link, styled } from '@mui/material';

import { GRADIENTS } from '@internal/components/app/constants';

export const PageRoot = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.main.white,
  backgroundImage: GRADIENTS.hero,
  backgroundAttachment: 'fixed',
}));

export const TopBar = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: theme.spacing(1.75, 2),

  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(1.75, 3),
  },
}));

export const ContentColumn = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: 720,
  margin: '0 auto',
  padding: theme.spacing(1, 2, 5),
  flex: 1,

  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(1.5, 5, 6),
  },
}));

export const ContentCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.main.white,
  borderRadius: 16,
  boxShadow: '0 20px 50px -28px rgba(6, 14, 21, 0.14)',
  padding: theme.spacing(3, 2.5),

  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(4, 6),
  },
}));

export const OptionRow = styled(Box, {
  shouldForwardProp: prop => prop !== '$selected',
})<{ $selected?: boolean }>(({ theme, $selected }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  padding: theme.spacing(2.25, 2.5),
  borderRadius: 6,
  cursor: 'pointer',
  border: '1px solid',
  borderColor: $selected
    ? theme.palette.contrast.main
    : 'rgba(6, 14, 21, 0.12)',
  backgroundColor: $selected ? '#F5F4FC' : 'transparent',
  transition: 'background-color 150ms ease, border-color 150ms ease',

  '&:hover': {
    backgroundColor: $selected ? '#F5F4FC' : theme.palette.main.grey50,
  },
}));

export const ImportRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  padding: theme.spacing(2.5),
  borderRadius: 8,
  border: '1px solid rgba(6, 14, 21, 0.12)',
  backgroundColor: theme.palette.main.white,

  [theme.breakpoints.up('md')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export const IconTile = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  flex: '0 0 auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 6,
  backgroundColor: theme.palette.main.grey100,
  color: theme.palette.contrast.main,
}));

export const LegalLink = styled(Link)(({ theme }) => ({
  color: theme.palette.contrast.main,
  fontWeight: 500,
  textDecorationColor: 'rgba(6, 14, 21, 0.4)',
}));

export const StepDot = styled(Box, {
  shouldForwardProp: prop => prop !== '$state',
})<{ $state: 'done' | 'current' | 'upcoming' }>(({ theme, $state }) => ({
  width: 32,
  height: 32,
  flex: '0 0 auto',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 14,
  fontWeight: 600,
  backgroundColor:
    $state === 'upcoming'
      ? theme.palette.main.grey100
      : theme.palette.contrast.main,
  color:
    $state === 'upcoming'
      ? theme.palette.main.grey500
      : theme.palette.contrast.contrastText,
}));

export const StepConnector = styled(Box, {
  shouldForwardProp: prop => prop !== '$reached',
})<{ $reached?: boolean }>(({ theme, $reached }) => ({
  flex: 1,
  borderTop: '1px solid',
  borderColor: $reached
    ? theme.palette.contrast.main
    : theme.palette.main.grey200,
}));

export const GoogleButtonWrap = styled(Box, {
  shouldForwardProp: prop => prop !== '$loading',
})<{ $loading?: boolean }>(({ $loading }) => ({
  position: 'relative',
  width: '100%',
  opacity: $loading ? 0.6 : 1,
  pointerEvents: $loading ? 'none' : 'auto',

  '@media (hover: hover)': {
    '&:hover .MuiButton-root': {
      backgroundColor: '#FAFAFA',
    },
  },
}));

export const StepPane = styled(Box, {
  shouldForwardProp: prop => prop !== '$hidden',
})<{ $hidden?: boolean }>(({ $hidden }) => ({
  display: $hidden ? 'none' : 'block',
}));
